import React, { forwardRef } from "react";
import PropTypes from "prop-types";

const CardSection = forwardRef(({ title, children }, ref) => (
  <div className="tw-mt-[24px] tw-flex tw-flex-col tw-gap-[24px]" ref={ref}>
    <div className="tw-text-gray-50 tw-text-[20px] tw-leading-[20px] tw-uppercase tw-text-center">
      {title}
    </div>
    <div className="tw-h-[500px]">{children}</div>
  </div>
));

CardSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
};

CardSection.defaultProps = {
  children: null,
};

export default CardSection;
